import ApiService from '@/app/framework/services/ApiServices'
import { Endpoints } from '@/app/framework/misc/Endpoints'
import { DashboardRepositoryInterface } from '@/data/persistences/repositories/contracts/DashboardRepositoryInterface'
import { Dashboard } from '@/domain/entities/Dashboard'
import { DashboardDataMapper } from '@/data/persistences/mappers/DashboardDataMapper'

export class DashboardApiRepository implements DashboardRepositoryInterface {
  private service: ApiService
  private mapper: DashboardDataMapper

  constructor(service: ApiService, mapper: DashboardDataMapper) {
    this.service = service
    this.mapper = mapper
  }

  public async getAll(params: Object): Promise<Dashboard> {
    const resp = await this.service.invoke(
      'get',
      Endpoints.Route.ADMIN_DASHBOARD,
      params
    )
    return this.mapper.convertFromApi(resp)
  }
}
